import Ris from 'ramda/es/is';

import { DEFAULT_ERROR_MESSAGE } from '@features/error-handler/constants';

export const mapErrorMessage = (error): string => {
  if (Ris(String, error) && error.length) return error;

  return DEFAULT_ERROR_MESSAGE;
};
